"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.text = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _tokens = require("./tokens");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Create style keys for a specific `textStyle.*` token, to be spread
 * onto any style object within `StyleSheet`
 * @param {String} key
 * @return {Object}
 */
var text = {
  styles: function styles() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref.target,
        fallback = _ref.fallback,
        color = _ref.color,
        font = _ref.font,
        lineHeight = _ref.lineHeight,
        letterSpacing = _ref.letterSpacing,
        textDecoration = _ref.textDecoration;

    var shared = {
      target: target,
      tokenKey: 'textStyle',
      resolver: _tokens.resolveTextStyleValue
    };

    var _ref2 = font || {},
        family = _ref2.family,
        size = _ref2.size,
        weight = _ref2.weight;

    return {
      color: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'color',
        fallback: [color, fallback]
      })),
      fontFamily: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.family',
        fallback: [family, fallback]
      })),
      fontSize: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.size',
        fallback: [size, fallback]
      })),
      fontWeight: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.weight',
        fallback: [weight, fallback]
      })),
      lineHeight: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'lineHeight',
        fallback: [lineHeight, fallback]
      })),
      letterSpacing: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'letterSpacing',
        fallback: [letterSpacing, fallback]
      })),
      textDecoration: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'textDecoration',
        fallback: [textDecoration, fallback]
      }))
    };
  },
  tokens: function tokens() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref3.target,
        fallback = _ref3.fallback,
        color = _ref3.color,
        font = _ref3.font,
        lineHeight = _ref3.lineHeight,
        letterSpacing = _ref3.letterSpacing,
        textDecoration = _ref3.textDecoration;

    var shared = {
      target: target,
      tokenKey: 'textStyle',
      resolver: _tokens.resolveTextStyleValue
    };

    var _ref4 = font || {},
        family = _ref4.family,
        size = _ref4.size,
        weight = _ref4.weight;

    return {
      color: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'color',
        fallback: [color, fallback]
      })),
      font: {
        family: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.family',
          fallback: [family, fallback]
        })),
        size: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.size',
          fallback: [size, fallback]
        })),
        weight: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.weight',
          fallback: [weight, fallback]
        }))
      },
      lineHeight: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'lineHeight',
        fallback: [lineHeight, fallback]
      })),
      letterSpacing: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'letterSpacing',
        fallback: [letterSpacing, fallback]
      })),
      textDecoration: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'textDecoration',
        fallback: [textDecoration, fallback]
      }))
    };
  }
};
exports.text = text;